import { BiogasviewDocument } from 'global/models/BiogasviewDocument';

export class IndexFacturation{
	nom: string;
	valeur: number;
	constructor(nom:string,valeur: number=0.0){
		this.nom = nom;
		this.valeur = valeur
	}
}